import type { ReactElement } from 'react';

/**
 * Tells the user how the create-studio flow resolved: LINKED to a Studio that
 * already existed (the server deduped an idempotent create — ENG-4209) versus
 * CREATED a brand-new one. Kept as a tiny presentational component so the copy is
 * unit-testable in isolation and stays consistent with the wizard's text style.
 *
 * Non-interactive status text (no onClick), so a plain element with role="status"
 * is correct — screen readers announce the outcome. No brand-specific copy, so it
 * is whitelabel/Hive-safe.
 *
 * Per rules (ai.knowledge/global): ui-architecture (whitelabel-safe, no hard-coded
 * brand values), code-comments-required, reference-rules-in-comments.
 */
export const StudioCreatedNotice = ({
  alreadyExisted
}: {
  readonly alreadyExisted: boolean;
}): ReactElement => (
  <div className='mt-8 text-sm text-muted' role='status'>
    {alreadyExisted ? 'Linked to your existing Studio.' : 'New Studio created.'}
  </div>
);
